import { render, staticRenderFns } from "./erp-bind.vue?vue&type=template&id=77d162e6&scoped=true&"
import script from "./erp-bind.vue?vue&type=script&lang=js&"
export * from "./erp-bind.vue?vue&type=script&lang=js&"
import style0 from "./erp-bind.vue?vue&type=style&index=0&id=77d162e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d162e6",
  null
  
)

export default component.exports